import React from 'react';

// Fonctions partagées par la liste (PlanningMobile) et le dossier (DossierMobile)
// de la version téléphone du Planning.

export const JOURS_COURTS = ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'];

export const jourIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const depuisIso = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(y, m - 1, d); };

export const normaliser = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
export const idDossier = (i) => (i.is_complement ? i.parent_intervention_id : i.id);

export const hhmm = (v) => {
  if (!v) return '';
  const s = String(v);
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? '' : `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const duree = (h) => {
  const n = Number(h) || 0;
  const heures = Math.floor(n);
  const minutes = Math.round((n - heures) * 60);
  if (!heures) return `${minutes} min`;
  return minutes ? `${heures} h ${String(minutes).padStart(2, '0')}` : `${heures} h`;
};

export const dateCourte = (iso) => {
  if (!iso) return '';
  const d = depuisIso(String(iso).slice(0, 10));
  return `${JOURS_COURTS[d.getDay()]}. ${d.getDate()}/${String(d.getMonth() + 1).padStart(2, '0')}`;
};

// Même lecture que la carte de la grille (`statutPiecesCarte`) : la livraison
// suivie au carnet prime sur la valeur figée du dossier.
export const etatPieces = (i) => {
  switch (i.pieces_statut_livraison) {
    case 'livre': return 'disponible';
    case 'en_commande':
    case 'recu_partiellement': return 'en_commande';
    default: return i.statut_pieces || '';
  }
};

export const PHASES = [
  { cle: 'tous', libelle: 'Tous' },
  { cle: 'avenir', libelle: 'À venir' },
  { cle: 'surplace', libelle: 'Sur place' },
  { cle: 'atelier', libelle: "À l'atelier" },
  { cle: 'prets', libelle: 'Prêts' },
  { cle: 'restitue', libelle: 'Restitués' },
];

// Les statuts atelier sont un référentiel ordonné (colonne `ordre`) : tout ce
// qui précède « Réceptionné » est « À venir », « À facturer » et « Facturé »
// sont « Prêts », « Restitué » ferme la marche. Le reste est « À l'atelier »,
// attentes de pièces, d'accord client et de garantie comprises (décision du
// 23/10). « Sur place » ne vient pas du statut : c'est la file d'accueil du
// jour (client arrivé ou en réception).
export const rangsStatuts = (statuts) => {
  const rangs = new Map();
  statuts.forEach((s, idx) => rangs.set(s.id, idx));
  const reception = statuts.find(s => normaliser(s.nom) === 'receptionne');
  return { rangs, rangReception: reception ? rangs.get(reception.id) : null };
};

export const phaseStatut = (statutId, statutNom, { rangs, rangReception }) => {
  const nom = normaliser(statutNom);
  if (nom === 'restitue') return 'restitue';
  if (nom === 'a facturer' || nom === 'facture') return 'prets';
  if (!statutId) return 'avenir';
  const rang = rangs.get(statutId);
  if (rang != null && rangReception != null && rang < rangReception) return 'avenir';
  return 'atelier';
};

export function Plaque({ immat }) {
  if (!immat) return null;
  return <span className="pm-plaque">{immat}</span>;
}
